import React from "react"
import PropTypes from "prop-types"
import TagGroup from "./TagGroup/TagGroup"
import "./Tag.scss"

const Tag = ({ text, onDelete, maxWidth, moreProps, disabled, readOnly, style = {} }) => {
  let classNames = ["prime-tag"]
  if (disabled) classNames.push("disabled")
  if (readOnly) classNames.push("read-only")

  let tagStyle = {}
  if (maxWidth) {
    tagStyle = {
      maxWidth,
      textOverflow: "ellipsis",
    }
  }
  return (
    <div
      className={classNames.join(" ")}
      style={{ ...tagStyle, ...style }}
      {...moreProps}
    >
      {text}
      {disabled !== true && readOnly !== true && (
        <i
          className="fal fa-times-circle prime-tag-icon"
          onClick={() => onDelete(text)}
        />
      )}
    </div>
  )
}

Tag.Group = TagGroup

Tag.propTypes = {
  text: PropTypes.string,
  onDelete: PropTypes.func,
  maxWidth: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  moreProps: PropTypes.object,
  style: PropTypes.object,
}

export default Tag
